export default __webpack_public_path__ + "static/media/eps.2b252e12.svg";